<template lang="pug">
  merge-item-row(:show-divider="showDivider" align="center")
    // Merge text
    template(#firstColumn)
      .text-xs.neutral500--text.font-semibold {{ title }}
    // Merge from
    template(#secondColumn)
      v-radio-group.ma-0(v-model="leftSelection" hide-details)
        v-radio(value="left" color="neutral700" @change="handleLeftSelection")
          template(#label)
            div(v-if="isImage")
              v-img.round-lg(v-if="hasImage.mergeFrom" :src="mergeFromItem.file" width="32" height="43" contain)
              v-sheet.neutral300.round-lg.d-flex.align-center.justify-center(v-else style="height: 43px; width: 32px;")
                v-icon(size="20" color="var(-v-neutral500)") $yzi-user-03
            div.text-sm.font-medium.neutral700--text(v-else)
              div(v-if="isAddress") {{ getAddressInString(mergeFromItem) }}
              div(v-else) {{ mergeFromItem }}
    // Merge into
    template(#thirdColumn)
      v-radio-group.ma-0(v-model="rightSelection" hide-details)
        v-radio(value="right" color="neutral700" :disabled="!mergeIntoItem" @change="handleRightSelection")
          template(#label)
            div(v-if="isImage")
              v-img.round-lg(v-if="hasImage.mergeInto" :src="mergeIntoItem.file" width="32" height="43" contain)
              v-sheet.neutral300.round-lg.d-flex.align-center.justify-center(v-else style="height: 43px; width: 32px;")
                v-icon(size="20" color="var(-v-neutral500)") $yzi-user-03
            div.text-sm.font-medium.neutral700--text(v-else)
              div(v-if="isAddress") {{ getAddressInString(mergeIntoItem) }}
              div(v-else) {{ mergeIntoItem }}
</template>

<script>
import MergeItemRow from "@/components/clinic/patient/merge/MergeItemRow.vue";

export default {
  components: {MergeItemRow},
  props: {
    title: {
      type: String,
      default: null
    },
    showDivider: {
      type: Boolean,
    },
    isImage: {
      type: Boolean,
    },
    isAddress: {
      type: Boolean,
    },
    mergeFromItem: {
      type: [String, Number, Object],
      default: null
    },
    mergeIntoItem: {
      type: [String, Number, Object],
      default: null
    },
  },
  data() {
    return {
      leftSelection: 'left',
      rightSelection: null,
    }
  },
  watch: {
    mergeFromItem() {
      if (this.leftSelection) {
        this.$emit('change', this.mergeFromItem)
      }
    },
    mergeIntoItem() {
      if (this.rightSelection) {
        this.$emit('change', this.mergeIntoItem)
      }
    }
  },
  computed: {
    hasImage() {
      return {
        mergeFrom: !!this.mergeFromItem?.file,
        mergeInto: !!this.mergeIntoItem?.file,
      }
    }
  },
  methods: {
    handleLeftSelection() {
      if (this.rightSelection) {
        this.rightSelection = null
      }
      this.$emit('change', this.mergeFromItem)
    },
    handleRightSelection() {
      if (this.leftSelection) {
        this.leftSelection = null
      }
      this.$emit('change', this.mergeIntoItem)
    },
    getAddressInString(addr) {
      if (!addr) {
        return ''
      }
      let address = ''
      if (addr.address_1) {
        address += addr.address_1
      }
      if (addr.address_2) {
        address += `, ${addr.address_2}`
      }
      if (addr.postcode) {
        address += `, ${addr.postcode}`
      }
      if (addr.city) {
        address += `, ${addr.city}`
      }
      if (addr.state) {
        address += `, ${addr.state}`
      }
      if (addr.country) {
        address += `, ${addr.country}`
      }
      return address
    },
  },
}
</script>

<style scoped>
</style>